import { createSlice } from "@reduxjs/toolkit";

const instituteContextSlice = createSlice({
  name: "instituteContext",
  initialState: (() => {
    const selectedInstitute = localStorage.getItem("selectedInstitute");
    const isInInstituteContext = localStorage.getItem("isInInstituteContext") === "true";
    return {
      selectedInstitute: selectedInstitute ? JSON.parse(selectedInstitute) : null,
      isInInstituteContext,
      isSwitching: false,
      switchingMessage: "",
    };
  })(),
  reducers: {
    enterInstitute: (state, action) => {
      state.selectedInstitute = action.payload;
      state.isInInstituteContext = true;
      localStorage.setItem("selectedInstitute", JSON.stringify(action.payload));
      localStorage.setItem("isInInstituteContext", "true");
    },
    exitInstitute: (state) => {
      state.selectedInstitute = null;
      state.isInInstituteContext = false;
      localStorage.removeItem("selectedInstitute");
      localStorage.removeItem("isInInstituteContext");
    },
    updateSelectedInstitute: (state, action) => {
      if (state.selectedInstitute && action.payload) {
        state.selectedInstitute = { ...state.selectedInstitute, ...action.payload };
        localStorage.setItem("selectedInstitute", JSON.stringify(state.selectedInstitute));
      }
    },
    setInstituteSwitching: (state, action) => {
      const { active, message = "" } = action.payload || {};
      state.isSwitching = Boolean(active);
      state.switchingMessage = active ? message : "";
    },
  },
});

export const {
  enterInstitute,
  exitInstitute,
  updateSelectedInstitute,
  setInstituteSwitching,
} = instituteContextSlice.actions;
export default instituteContextSlice.reducer;
